export const isUrl = (url?: string) => {
    if (!url || url.trim().length === 0) {
        return false;
    }

    try {
        new URL(url);

        return true;
    } catch {
        return false;
    }
};
